<template>
  <div class="dashboard__container" v-if="user">
    <div class="dashboard__container--body ">
      

      <div class="dashboard__container--body--col">
        <div>
        <h4 class="mb-3">JES Interview Questions</h4>
        <form ref="form" @submit.prevent>
          <div class="mb-3">
            <label for="want">Explain the job details. Do they actually want the job?</label>
            <v-select
              label="title" 
              :options="yesNo"
              multiple
              v-model="form.want"
              >
            </v-select>
          </div>
          <div class="mb-3">
            <label for="transportation">Do they have reliable transportation?</label>
            <v-select
              label="title" 
              :options="yesNo"
              multiple
              v-model="form.transportation"
              >
            </v-select>
          </div>
          <div class="mb-3">
            <label for="when">When are they able to start?</label>
            <input type="date" placeholder="" v-model.trim="form.when" id="when" />
          </div>
          <div class="mb-3">
            <label for="forty">Are they able to lift and move a box that weighs 40lbs?</label>
            <v-select
              label="title" 
              :options="yesNo"
              v-model="form.forty"
              >
            </v-select>
          </div>
          <div class="mb-3">
            <label for="standing">Are they comfortable standing and walking for long periods of time?</label>
            <v-select
              label="title" 
              :options="yesNo"
              v-model="form.standing"
              >
            </v-select>
          </div>
          <div class="mb-3">
            <label for="background">Is there anything we should be aware of when we run their background check?</label>
            <v-select
              label="title" 
              :options="yesNo"
              v-model="form.backgroundIssues"
              >
            </v-select>
            <transition name="fade">
              <div class="mt-3" v-if="form.backgroundIssues == 'Yes'">
                <label for="explain">Explain:</label>
                <input type="text" placeholder="" v-model.trim="form.explain" id="explain" />
              </div>
            </transition>
          </div>
          <div class="mb-3">
            <label for="passDrugTest">Are they confident that they would pass a drug test?</label>
            <v-select
              label="title" 
              :options="yesNo"
              v-model="form.passDrugTest"
              >
            </v-select>
          </div>
          <div class="mb-3">
            <label for="transportation">Will they get the drug test done quickly when they get the instructions?</label>
            <v-select
              label="title" 
              :options="yesNo"
              v-model="form.quickDrugTest"
              >
            </v-select>
          </div>
          <div class="mb-3">
            <label for="shifts">What shifts are they able to work?</label>
            <input type="text" placeholder="" v-model.trim="form.shifts" id="shifts" />
          </div>
          <div class="mb-3">
            <label for="everee">Did you explain the process of setting up a new account with Everee for YES?</label>
            <v-select
              label="title" 
              :options="yesNo"
              v-model="form.evereeJES"
              >
            </v-select>
          </div>
          <div class="mb-3">
            <label for="notes">Notes from Interviewer:</label>
            <textarea name="notes" id="" cols="30" rows="2" v-model.trim="form.notes"></textarea>
          </div>
          <div>
            <button class="btn btn__primary mt-2" @click="addInterview()">Submit
              <transition name="fade">
                <span class="ml-2" v-if="performingRequest">
                <i class="fa fa-spinner fa-spin"></i>
                </span>
              </transition>
            </button>
          </div>
        </form>
        </div>
      </div>

      <div class="dashboard__container--body--col" v-if="user.JESInterview">
        <div>
          <h4 class="mb-3">User Completed Interview</h4>
          <p class="strong">Do they want the job?</p>
          <p v-if="user.JESInterview.want">{{user.JESInterview.want[0]}}</p>
          <p class="strong">transportation</p>
          <p v-if="user.JESInterview.transportation">{{user.JESInterview.transportation[0]}}</p>
          <p class="strong">When they can start</p>
          <p v-if="user.JESInterview.when">{{user.JESInterview.when}}</p>
          <p class="strong">Can lift 40lbs</p>
          <p v-if="user.JESInterview.forty">{{user.JESInterview.forty}}</p>
          <p class="strong">Can stand for long periods of time.</p>
          <p v-if="user.JESInterview.standing">{{user.JESInterview.standing}}</p>
          <p class="strong">Background Issues</p>
          <p v-if="user.JESInterview.backgroundIssues">{{user.JESInterview.backgroundIssues}}</p>
          <p class="strong">Explanation</p>
          <p v-if="user.JESInterview.explain">{{user.JESInterview.explain}}</p>
          <p class="strong">Will pass drug test</p>
          <p v-if="user.JESInterview.passDrugTest">{{user.JESInterview.passDrugTest}}</p>
          <p class="strong">Will take drug test quickly</p>
          <p v-if="user.JESInterview.quickDrugTest">{{user.JESInterview.quickDrugTest}}</p>
          <p class="strong">Did you explain they will need a new Everee account with JES?</p>
          <p v-if="user.JESInterview.evereeJES">{{user.JESInterview.evereeJES}}</p>
          <p class="strong">Preferred Shift</p>
          <p v-if="user.JESInterview.shifts">{{user.JESInterview.shifts}}</p>
          <p class="strong">Notes:</p>
          <p v-if="user.JESInterview.notes">{{user.JESInterview.notes}}</p>
           <p v-if="user.JESInterview && user.JESInterview.interviewBy">Interiewed by {{user.JESInterview.interviewBy}} on {{formatDate(user.JESInterview.interviewed)}}</p>
        </div>
      </div>

      <div class="dashboard__container--body--col" v-if="user.interview">
        <div>
          <h4 class="mb-3">User Completed Interview</h4>
          <p class="strong">Job Interest</p>
          <p><button class="chipDark" v-for="(type, index) in user.interview.types" :key="index">{{type}}</button></p>
          <p class="strong">House Per Week</p>
          <p><button class="chipDark" v-for="(hour, index) in user.interview.hours" :key="index">{{hour}}</button></p>
          <p class="strong">Experience</p>
          <p>{{user.interview.experience}}</p>
          <p class="strong">Can lift 40lbs</p>
          <p>{{user.interview.forty}}</p>
          <p class="strong">Can stand for long periods of time.</p>
          <p>{{user.interview.standing}}</p>
          <p class="strong">Background Issues</p>
          <p>{{user.interview.background}}</p>
          <p class="strong">Explanation</p>
          <p>{{user.interview.explain}}</p>
          <p class="strong">Will pass drug test</p>
          <p>{{user.interview.passDrugTest}}</p>
          <p class="strong">Has reliable transportation</p>
          <p>{{user.interview.transportation}}</p>
          <p class="strong">Willing to with nights and weekends</p>
          <p>{{user.interview.nightsWeekends}}</p>
          <p class="strong">Anything else?</p>
          <p>{{user.interview.anythingElse}}</p>
          <p class="strong">When they can start</p>
          <p>{{user.interview.when}}</p>
          <!-- <p class="strong">Notes from Interviewer</p>
          <p>{{user.interview.notes}}</p>
          <p>Interiewed by {{user.interview.interviewBy}} on {{formatDate(user.interview.interviewed)}}</p> -->
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as moment from 'moment'
const fb = require('../../firebaseConfig.js')

export default {
  props: ['user'],
  data: () => ({
    performingRequest: false,
    types: ['Food and Beverage', 'Janitorial', 'Guest Services', 'Housekeeping'],
    hours: ['0-10', '10-20', '20-30', '30-40'],
    yesNo: ['Yes', 'No'],
    form: {    },
  }),
  name: 'userInterview',
  computed: {
    ...mapState(['currentUser', 'userProfile']),
  },
  methods: {
    formatDate(q) {
      if(q) {
        const postedDate = new Date(q.seconds) * 1000;
        return moment(postedDate).format('MMM Do, YYYY')
      } else {
        return null
      }
    },
    addInterview() {
      this.form.interviewBy = this.userProfile.firstName + ' ' + this.userProfile.lastName
      this.form.interviewed = fb.firestore.FieldValue.serverTimestamp()

      fb.usersCollection.doc(this.user.id).update({
        JESInterview: this.form,
      })
      setTimeout(() => {
        this.performingRequest = false
        this.form = {}
      }, 2000)
    }
  },
}

</script>